import { memo, useMemo } from "react";
import { makeStyles } from "tss-react/mui";
import { MiAvatarCard } from "@miplatform/components";
import { useAnchor } from "@miplatform/hooks";
import { getDocumentUrl } from "@miplatform/utils";
import { Divider, Menu, Typography } from "@mui/material";
import { Box } from "@mui/system";
import { getIssueUsers } from "./issuesUtil";

export const IssueUsersHeader = memo(
  ({ title, attempt, issue, users = [] }) => {
    const { classes } = useStyles();
    const [anchorEl, handleOpen, handleClose] = useAnchor();
    const issueUsers = useMemo(
      () => getIssueUsers(attempt, issue, users),
      [attempt, issue, users]
    );
    const isMultipleUsers = issueUsers.length > 1;

    return (
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="body1" fontWeight="bold">
          {title}
        </Typography>
        <Box display="flex" gap={2} alignItems="center">
          {issue.areaName && (
            <Typography className={classes.text} variant="body2">
              {issue.areaName}
            </Typography>
          )}
          {issue.time && (
            <>
              <Divider orientation="vertical" variant="middle" flexItem />
              <Typography className={classes.text} variant="body2">
                {issue.time}
              </Typography>
            </>
          )}
          <Divider orientation="vertical" variant="middle" flexItem />
          <MiAvatarCard
            text={issueUsers.length > 0 ? issueUsers[0]?.name : "Unassigned"}
            testId="issue-main-user"
            src={getDocumentUrl(issueUsers[0]?.profilePicture?.id)}
            small
            isDropDown={isMultipleUsers}
            onClick={handleOpen}
          />
          <Menu
            anchorEl={anchorEl}
            open={anchorEl && isMultipleUsers}
            onClose={handleClose}
            classes={{
              list: classes.menu,
            }}
          >
            {issueUsers.slice(1).map((x, index) => (
              <MiAvatarCard
                testId={`issue-user-${index}`}
                key={x.userId}
                text={x?.name}
                src={getDocumentUrl(x.profilePicture?.id)}
                small
              />
            ))}
          </Menu>
        </Box>
      </Box>
    );
  }
);

const useStyles = makeStyles()((theme) => ({
  text: {
    color: theme.palette.grey.medium,
    fontWeight: theme.typography.fontWeightBold,
    lineHeight: 2,
  },
  menu: {
    paddingBottom: 0,
    paddingTop: 0,
  },
}));
